import { FC, useEffect } from 'react';
import { useHits } from 'react-instantsearch';
import { AlgoliaProductHit } from '../../shared/types';
import { AlgoliaUtil } from '../../shared/utils';
import { calculateAvailabilityAndLeadTime, type InventoryPolicy } from '../../helpers/availability-lead-time';

type CollectionDataLayerProps = {
  algoliaUtil: AlgoliaUtil;
};

export const CollectionDataLayer: FC<CollectionDataLayerProps> = ({ algoliaUtil }) => {
  const { results } = useHits<AlgoliaProductHit>();

  useEffect(() => {
    if (results?.hits?.length) {
      window.ultimateShopifyDataLayer?.sendCollectionsPageData(
        results?.hits
          ?.map((hit: AlgoliaProductHit) => ({ rawHit: hit, hit: algoliaUtil.normalizeProductHit(hit) }))
          ?.map(({ hit, rawHit }) => {
            const { availabilityStatus, leadTime } = calculateAvailabilityAndLeadTime(
              hit.leadTimeArray,
              hit.variantsInventoryCount,
              hit.inventoryPolicy as InventoryPolicy,
              1,
              hit.useUp
            );

            return {
              variant_id: Number(hit.shopifyObjectID),
              vendor: rawHit.vendor,
              sku: hit.sku,
              handle: hit.handle,
              product_title: hit.title,
              final_price: hit.basePrice * 100,
              quantity: 1,
              availability: availabilityStatus,
              lead_time: leadTime,
            };
          })
      );
    }
  }, [results?.queryID]);

  return null;
};
